import { PageHeader } from '@/shared/layouts/PageHeader';
import { useUser } from '@/shared/hooks/useAuth';
import { DashboardLayoutEngine } from '../infrastructure/layout/DashboardLayoutEngine';
import { DashboardLayoutConfig } from '../infrastructure/contracts/layout.contract';
import { DashboardProvider } from '../infrastructure/hooks/DashboardProvider';
import { registerEmployeeWidgets } from '../widgets/employee/register';
import { registerSharedWidgets } from '../widgets/shared/registerSharedWidgets';

// Reuse the existing employee widget set — all are backed by personal /
// non-admin endpoints (/api/my/stats, /api/tasks, /api/projects, /api/activity,
// /api/announcements, /api/jobs, /api/time-logs/today), so they work for
// manager / team_lead / bde / developer without admin-only authorization.
registerEmployeeWidgets();
registerSharedWidgets();

const operationalLayout: DashboardLayoutConfig = {
  id: 'operational-default',
  name: 'Operational Layout',
  description: 'Shared operational dashboard for manager, team lead, BDE and developer roles',
  role: 'manager',
  widgets: [
    { id: 'dash-employee-overview', w: 12, h: 1, x: 0, y: 0 },
    { id: 'dash-time-summary', w: 12, h: 1, x: 0, y: 1 },
    { id: 'dash-ai-briefing', w: 12, h: 2, x: 0, y: 2 },
    { id: 'dash-upcoming-meetings', w: 12, h: 2, x: 0, y: 4 },
    { id: 'dash-pending-tasks', w: 12, h: 2, x: 0, y: 6 },
    { id: 'dash-active-projects', w: 12, h: 2, x: 0, y: 8 },
    { id: 'dash-notifications', w: 12, h: 2, x: 0, y: 10 },
    { id: 'dash-recent-activities', w: 12, h: 2, x: 0, y: 12 },
    { id: 'dash-announcements', w: 12, h: 2, x: 0, y: 14 },
  ],
};

const ROLE_LABELS: Record<string, string> = {
  manager: 'Manager',
  team_lead: 'Team Lead',
  bde: 'BDE',
  developer: 'Developer',
};

export function OperationalDashboard() {
  const user = useUser();
  const roleLabel = ROLE_LABELS[user?.role ?? ''] ?? 'Team';

  return (
    <DashboardProvider>
      <PageHeader
        title={`Welcome back, ${user?.displayName || roleLabel}`}
        description="Your operational overview for today."
        breadcrumbs={[{ label: 'Home', to: '/' }, { label: 'Dashboard' }]}
      />
      <div className="mt-6">
        <DashboardLayoutEngine layout={operationalLayout} />
      </div>
    </DashboardProvider>
  );
}
